import BaseError from '@whr/core_utils/baseError.js';
export var ConfigurationUnknownErrorCode;
(function (ConfigurationUnknownErrorCode) {
    ConfigurationUnknownErrorCode["UNKNOWN"] = "CONFIGURATION|UNKNOWN";
})(ConfigurationUnknownErrorCode || (ConfigurationUnknownErrorCode = {}));
export class ConfigurationUnknownError extends BaseError {
    constructor(message, originalError) {
        super(ConfigurationUnknownErrorCode.UNKNOWN, message, originalError, 500);
    }
}
//# sourceMappingURL=unknown_error.js.map